import script from "./CrossStep.vue?vue&type=script&setup=true&lang=js"
export * from "./CrossStep.vue?vue&type=script&setup=true&lang=js"

import "./CrossStep.vue?vue&type=style&index=0&id=07a983bc&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-07a983bc"]])

export default __exports__